<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-text-field
          v-model="ticket.ncdMac"
          label="What is the NCD MAC address?	"
          placeholder=" "
          outlined
          dense
          :readonly="false"
        ></v-text-field>
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.cablesChecked"
        >
          <label class="mr-2">Have the cables been checked?</label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.ncdConnected"
        >
          <label class="mr-2">Is the NCD connected to the first socket? </label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="ticket.category != 'speed'"
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.serviceWorked"
        >
          <label class="mr-2">Has the service ever worked?  </label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="ticket.category == 'speed'"
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.issueExistOutsidePeak"
        >
          <label class="mr-2">Does the issue exist outside of peak time? </label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="ticket.category == 'speed'"
        cols="12"
        md="12"
        lg="12"
        class="pb-0"
      >
        <v-radio-group
          row
          v-model="ticket.cvcNotCongested"
        >
          <label class="mr-2">Have you confirmed that the CVC is not congested?</label>
          <v-radio label="Yes" value="Yes"></v-radio>
          <v-radio label="No" value="No"></v-radio>
        </v-radio-group>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="PowerStatus"
            label="Power Status"
            name="Power Status"
            outlined
            placeholder="Please select Power Status"
            v-model="ticket.powerStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Power Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="Power Behaviour"
            name="Power Behaviour"
            outlined
            placeholder="Please select Power Behaviour"
            v-model="ticket.powerBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Link Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LinkStatus"
            label="Link Status"
            name="Link Status"
            outlined
            placeholder="Please select Link Status"
            v-model="ticket.linkStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Link Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="Link Behaviour"
            name="Link Behaviour"
            outlined
            placeholder="Please select Link Behaviour"
            v-model="ticket.linkBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="DSL Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="DslStatus"
            label="DSL Status"
            name="DSL Status"
            outlined
            placeholder="Please select DSL Status"
            v-model="ticket.dslStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="DSL Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="DSL Behaviour"
            name="DSL Behaviour"
            outlined
            placeholder="Please select DSL Behaviour"
            v-model="ticket.dslBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="LAN Status"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LanStatus"
            label="LAN Status"
            name="LAN Status"
            outlined
            placeholder="Please select LAN Status"
            v-model="ticket.lanStatus"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="LAN Behaviour"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="LedBehaviour"
            label="LAN Behaviour"
            name="LAN Behaviour"
            outlined
            placeholder="Please select LAN Behaviour"
            v-model="ticket.lanBehaviour"
          ></v-select>
        </ValidationProvider>
      </v-col>

    </v-row>
  </div>
</template>

<script>
export default {
  name: "nbn-check-list-details-fttc",
  props: {
    ticket: { type: Object },
  },
  data: () => ({
    PowerStatus: [
      {text: "Blue", value: "Blue", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    LinkStatus: [
      {text: "Blue", value: "Blue", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Blue/Red", value: "Blue/Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    DslStatus: [
      {text: "Blue", value: "Blue", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    LanStatus: [
      {text: "Blue", value: "Blue", disabled: false},
      {text: "Orange", value: "Orange", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    LedBehaviour: [
      {text: "Flashing", value: "Flashing", disabled: false},
      {text: "Solid", value: "Solid", disabled: false},
    ]
  })
}
</script>

<style scoped>

</style>
